import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class ComputeService {
  private computeSummary: any;
  constructor(public http: HttpClient) {
  }
  getComputeSummary() {
    return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/vcd/compute/summary')
      .map( res => this.computeSummary = res);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/dashboard/compute-service.component.ts